export const NEW_AGENCY_ADDED = 'ADDED_AGENCY';
export const SPOTLIGHT_AGENCY_REF_NUMBER = 50;